import { deleteBroadcast } from '../../../Api/mediaServerApi';
import { WebRTCAdaptor } from '../../../WebRTC/webrtc_adaptor';

let webRTCAdaptor = null;
let streamCanvas = null;
let streamCtx = null;

let videoPlayer;
let canvasStream;

let canvasSX = 0;
let canvasSY = 0;
let canvasSW = 404;
let canvasSH = 720;

export const publish = async (streamId, roomId) => {
  webRTCAdaptor.setStream(canvasStream);
  webRTCAdaptor.joinRoom(roomId, streamId);
};

export const updateStream = (stream) => {
  // Should not set, but replace..
  webRTCAdaptor.setStream(stream);
  // webRTCAdaptor.replaceVideoTrack(stream);
};

export const stop = async (streamId, roomId) => {
  await deleteBroadcast(streamId);
  webRTCAdaptor.leaveFromRoom(roomId);
  webRTCAdaptor.stop(streamId);
  webRTCAdaptor.closeWebSocket();
  webRTCAdaptor = null;
};

const calcVideoDrawSize = (player) => {
  const w = player.videoWidth;
  const h = player.videoHeight;
  if (h > w) {
    canvasSX = 0;
    canvasSW = w;
    canvasSH = h;
  } else {
    let targetAspectRatio = h / w;
    canvasSW = h * targetAspectRatio;
    canvasSX = w / 2 - canvasSW / 2;
    canvasSH = h;
  }
};

export const init = (websocketURL, streamId, tokenId, stream, videoElement) => {
  console.log('INIT GUEST STREAM');
  return new Promise((resolve, reject) => {
    try {
      videoPlayer = videoElement;
      calcVideoDrawSize(videoElement);
      streamCanvas = createStreamCavnas();
      streamCtx = streamCanvas.getContext('2d');

      draw();

      canvasStream = streamCanvas.captureStream(25);

      // Remove "dead" audio track
      const deadTrack = canvasStream.getAudioTracks()[0];
      if (deadTrack) canvasStream.removeTrack(deadTrack);

      // Add audio
      const audioTracks = stream.getAudioTracks();
      canvasStream.addTrack(audioTracks[0]);

      const pc_config = {
        iceServers: [
          {
            urls: 'stun:stun1.l.google.com:19302',
          },
        ],
      };

      const sdpConstraints = {
        OfferToReceiveAudio: false,
        OfferToReceiveVideo: false,
      };

      webRTCAdaptor = new WebRTCAdaptor({
        websocket_url: websocketURL,
        peerconnection_config: pc_config,
        sdp_constraints: sdpConstraints,
        debug: false,
        callback: (info, obj) => {
          if (info == 'initialized') {
            resolve();
          } else if (info == 'refreshConnection') {
            console.log('refreshConnection admin');
          } else if (info == 'joinedTheRoom') {
            webRTCAdaptor.publishStream(streamId, tokenId);
          }
        },
        callbackError: (error) => {
          console.log('WEBRTC GUEST ERROR', error);
        },
      });
    } catch (err) {
      reject(err);
    }
  });
};

const createStreamCavnas = () => {
  const canvas = document.createElement('canvas');
  canvas.width = 720 / 2;
  canvas.height = 1280 / 2;
  return canvas;
};

const draw = () => {
  if (videoPlayer) {
    streamCtx.drawImage(
      videoPlayer,
      canvasSX,
      canvasSY,
      canvasSW,
      canvasSH,
      0,
      0,
      streamCanvas.width,
      streamCanvas.height,
    );
  }
  requestAnimationFrame(draw);
};
